import { Routes } from '@angular/router';

import { LoginComponent } from './features/login/login/login.component';
import { ShellComponent } from './features/shell/shell.component';

import { BenutzerverwaltungComponent } from './features/benutzerverwaltung/pages/benutzerverwaltung/benutzerverwaltung.component';
import { BestelluebersichtComponent } from './features/bestellungen/pages/bestelluebersicht/bestelluebersicht.component';
import { BestellungDetailComponent } from './features/bestellungen/pages/bestellung-detail/bestellung-detail.component';
import { WareneingaengeUebersichtComponent } from './features/wareneingaenge/pages/wareneingaenge-uebersicht/wareneingaenge-uebersicht.component';
import { WareneingangDetailComponent } from './features/wareneingaenge/pages/wareneingang-detail/wareneingang-detail.component';
import { ReturnsUebersichtComponent } from './features/returns/pages/returns-uebersicht/returns-uebersicht.component';
import { ReturnsDetailComponent } from './features/returns/pages/returns-detail/returns-detail.component';
import { InventurUebersichtComponent } from './features/inventory/pages/inventur-uebersicht/inventur-uebersicht.component';
import { InventurErfassungComponent } from './features/inventory/pages/inventur-erfassung/inventur-erfassung.component';
import { EntlastungenUebersichtComponent } from './features/entlastungen/pages/entlastungen-uebersicht/entlastungen-uebersicht.component';
import { EntlastungDetailComponent } from './features/entlastungen/pages/entlastung-detail/entlastung-detail.component';
import { ChangePasswordComponent } from './features/change-password/pages/change-password.component';

import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { moduleGuard } from './core/guards/module.guard';
import { posBestellungLockGuard } from './core/guards/pos-bestellung-lock.guard';
import { posWareneingangLockGuard } from './core/guards/pos-wareneingang-lock.guard';
import { mustChangePasswordGuard } from './core/guards/must-change-password.guard';
import { ForgotPasswordComponent } from './features/password-reset/pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './features/password-reset/pages/reset-password/reset-password.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [authGuard],
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard, mustChangePasswordGuard],
    children: [
      {
        path: 'benutzerverwaltung',
        component: BenutzerverwaltungComponent,
        canActivate: [adminGuard],
      },
      {
        path: 'bestellungen',
        component: BestelluebersichtComponent,
        canActivate: [moduleGuard],
        data: {
          module: 'Bestellungen',
        },
      },
      {
        path: 'bestellungen/:id',
        component: BestellungDetailComponent,
        canActivate: [moduleGuard, posBestellungLockGuard],
        data: {
          module: 'Bestellungen',
        },
      },
      {
        path: 'wareneingaenge',
        component: WareneingaengeUebersichtComponent,
        canActivate: [moduleGuard],
        data: {
          module: 'Wareneingaenge',
        },
      },
      {
        path: 'wareneingaenge/:id',
        component: WareneingangDetailComponent,
        canActivate: [moduleGuard, posWareneingangLockGuard],
        data: {
          module: 'Wareneingaenge',
        },
      },
      {
        path: 'retouren',
        component: ReturnsUebersichtComponent,
        canActivate: [moduleGuard],
        data: {
          module: 'Retouren',
        },
      },
      {
        path: 'retouren/:filialNummer',
        component: ReturnsDetailComponent,
        canActivate: [moduleGuard],
        data: {
          module: 'Retouren',
        },
      },
      {
        path: 'entlastungen',
        component: EntlastungenUebersichtComponent,
        canActivate: [moduleGuard],
        data: {
          module: 'Entlastungen',
        },
      },
      {
        path: 'entlastungen/:filialNummer',
        component: EntlastungDetailComponent,
        canActivate: [moduleGuard],
        data: {
          module: 'Entlastungen',
        },
      },
      {
        path: 'inventur',
        component: InventurUebersichtComponent,
        canActivate: [moduleGuard],
        data: {
          module: 'Inventuren',
        },
      },
      {
        path: 'inventur/:inventoryId/filial/:filialNummer',
        component: InventurErfassungComponent,
        canActivate: [moduleGuard],
        data: {
          module: 'Inventuren',
        },
      },
      {
        path: 'keine-module',
        loadComponent: () =>
          import('./features/keine-module/keine-module.component').then(
            (m) => m.KeineModuleComponent
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];